import React from 'react';
import './ProjectGallery.css'; // Import your CSS file
import wall from '../images/ss waterproofing (0.2).jpg'
import foundation from '../images/foundation.jpeg'
import roof from '../images/roof-waterproofing-coating.jpg'
import bathrrom from '../images/bathroom-waterproofing-services.jpeg'
import basement from '../images/basement.jpg'
import Rebaring from '../images/rebar-fixing-contractor-service-500x500.jpg'
const projects = [
    {
      title: "Basement Transformation",
      description: "See how we transformed a damp, unusable basement into a dry, livable space.",
      imageUrl:basement
    },
    {
      title: "Roof Waterproofing",
      description: "Explore our roof waterproofing projects and the impressive results we've achieved.",
      imageUrl:roof
    },
    {
      title: "Wall Waterproofing",
      description: "Check out our wall waterproofing solutions and the difference they make.",
      imageUrl:wall
    },
    {
      title: "Foundation Sealing",
      description: "Learn about our foundation sealing process and the long-lasting protection it provides.",
      imageUrl:foundation
    },
    {
      title: "Bathroom Waterproofing",
      description: "Discover our bathroom waterproofing services that ensure a leak-free environment and prevent water damage.",
      imageUrl:bathrrom
    },
    {
        title: "Rebaring Work",
        description: "Explore our rebaring work, enhancing the strength and stability of structures during renovations or expansions.",
        imageUrl:Rebaring
      },
  ];

function ProjectGallery() {
  return (
    <section className="project-gallery" id='project1'>
      <div className="container">
        <h2 className="title">Project Gallery</h2>
        <div className="gridp">
          {projects.map((project, index) => (
            <div key={index} className="project-item">
              <div className="project-image">
                <img src={project.imageUrl} alt={project.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProjectGallery;
